import React from "react";
const SvgModalBack = props => (
  <svg viewBox="0 0 10 18" {...props}>
    <path
      fill="none"
      stroke="#1A1F24"
      strokeLinecap="round"
      strokeWidth={2}
      d="M9 17L1 8.986m0 .029L9 1"
    />
  </svg>
);
export default SvgModalBack;
